import React,{useEffect} from 'react'
import './Navbar.css';
import logotypeWhite from '../images/images-oakwood-school-logotype-white.svg';
import { FaRegIdBadge, FaSearch } from 'react-icons/fa';
import logo from '../logotw.png'
import logob from '../logotb.png'
import logoMark from "../images/images-oakwood-school-logo-mark.svg";
import { withRouter } from 'react-router-dom';    

const Navbar = (props) => {

    useEffect(() => {
        console.log(props.location.pathname)
    }, [props])

    return (
        <div id='main-navbar'>


            <header id="masthead" className="site-header" role="banner">

                <div id="page" className="hfeed site">

                    <form role="search" method="get" className="search-form" action="https://stories.oakwoodschool.org/">

                        <label>
                            <span className="screen-reader-text">Search for:</span>
                            <input type="search" className="search-field" placeholder="Search &hellip;" value="" name="s"
                                title="Search for:" /></label>
                        <input type="submit" className="search-submit" value="Search" /><button
                            className="search-close  js-search-close  icon-cancel-1"></button>
                    </form>


                    <a className="skip-link screen-reader-text" href="#content">Skip to content</a>
                    <div className="site-header__nav-wrapper-color">
                        <div className="site-header__nav-wrapper">
                            <div className="site-header__logotype"><span><img src={logotypeWhite}
                                alt="Oakwood School logo" /><a href="https://www.oakwoodschool.org/"
                                    target="_blank">oakwoodschool.org</a></span></div>
                            <div className="site-header__logomark"><a href="stories.oakwoodschool.html" rel="home"><img
                                src={logoMark} className="site-header__logomark__image"
                                alt="Oakwood Stories logo" /><span
                                    className="site-header__logomark__link  site-header__logomark__link--1">Stories</span> <span
                                        className="site-header__logomark__link  site-header__logomark__link--2">Home</span></a>
                            </div>
                            <img className="site-header__search" src={logo} style={{width:'8vw'}}/>
                            {/* <button className="site-header__search  js-search-open"><span
                                className="site-header__search__label"><FaSearch style={{ marginRight: '1rem' }} />Search</span></button> */}
                        </div>
                        <div className="site-color-bands  clear">

                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>



                {props.location.pathname=='/' &&<center>    
                    {/* <h1 className='logoH1' style={{ color: 'white', padding: '2rem', backgroundColor: 'rgba(0,0,0,0.4)' }}>
                    Oakwood Summer Programs Catalog</h1>
                     */}

                     <div style={{paddingTop:'3rem', backgroundColor:'rgba(240,240,241,.7)'}}>
                    <img src={logob} style={{width:'50%'}}/>
                    <h1 className='title-banner'>2021 Catalog</h1>
                    </div>
                    </center>}


            </header>

        </div>

    )
}

export default withRouter(Navbar)
